"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MEDIA_QUERIES", {
  enumerable: true,
  get: function get() {
    return _useNav2.MEDIA_QUERIES;
  }
});
Object.defineProperty(exports, "NAV_EXPANDED_STATES", {
  enumerable: true,
  get: function get() {
    return _useNav2.NAV_EXPANDED_STATES;
  }
});
Object.defineProperty(exports, "useStickyLeftNav", {
  enumerable: true,
  get: function get() {
    return _useStickyLeftNav.default;
  }
});
exports.default = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledComponentsModifiers = require("styled-components-modifiers");

var _modifiers = require("../../modifiers");

var _useNav2 = _interopRequireWildcard(require("./hooks/useNav"));

var _constants = require("./constants");

var _ExpanderButton = _interopRequireDefault(require("./ExpanderButton"));

var _Item = _interopRequireDefault(require("./Item"));

var _schema = _interopRequireDefault(require("./schema"));

var _useStickyLeftNav = _interopRequireDefault(require("./hooks/useStickyLeftNav"));

var _applyStyleModifiers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LeftNavFrame = _styledComponents.default.nav.withConfig({
  displayName: "LeftNav__LeftNavFrame",
  componentId: "wxiww2-0"
})(["", ";background-color:", ";flex-direction:column;height:100%;position:relative;width:", ";&:focus{outline:none;}a{text-decoration:none;}ul{list-style:none;}", ";"], (0, _modifiers.withFlex)(), (0, _toColorString.default)(_constants.BG_COLOR), (0, _rem.default)(_constants.LEFT_NAV_OPEN_WIDTH_PX), (0, _styledComponentsModifiers.applyStyleModifiers)((_applyStyleModifiers = {}, _defineProperty(_applyStyleModifiers, _useNav2.NAV_EXPANDED_STATES.COLLAPSED_XY, function () {
  return (0, _styledComponents.css)(["height:", ";width:", ";"], (0, _rem.default)(_constants.LEFT_NAV_CLOSED_WIDTH_PX), (0, _rem.default)(_constants.LEFT_NAV_CLOSED_WIDTH_PX));
}), _defineProperty(_applyStyleModifiers, _useNav2.NAV_EXPANDED_STATES.COLLAPSED_X, function () {
  return (0, _styledComponents.css)(["height:100%;width:", ";"], (0, _rem.default)(_constants.LEFT_NAV_CLOSED_WIDTH_PX));
}), _defineProperty(_applyStyleModifiers, _useNav2.NAV_EXPANDED_STATES.EXPANDED, function () {
  return (0, _styledComponents.css)(["height:100%;width:", ";"], (0, _rem.default)(_constants.LEFT_NAV_OPEN_WIDTH_PX));
}), _applyStyleModifiers), 'variant'));

var MenuItemsWrapper = _styledComponents.default.div.withConfig({
  displayName: "LeftNav__MenuItemsWrapper",
  componentId: "wxiww2-1"
})(["flex:1;"]);

var MenuItems = _styledComponents.default.ul.withConfig({
  displayName: "LeftNav__MenuItems",
  componentId: "wxiww2-2"
})(["margin:0;padding:0;"]);

function LeftNav(props) {
  var _useNav = (0, _useNav2.default)(props),
      getExpanderButtonProps = _useNav.getExpanderButtonProps,
      navExpandedState = _useNav.navExpandedState;

  var currentPath = props.currentPath,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items;
  return _react.default.createElement(LeftNavFrame, {
    variant: navExpandedState
  }, _react.default.createElement(_ExpanderButton.default, getExpanderButtonProps()), _react.default.createElement(MenuItemsWrapper, null, _react.default.createElement(MenuItems, null, items.map(function (item) {
    var key = item.text;
    return _react.default.createElement(_Item.default, {
      key: key,
      currentPath: currentPath,
      item: item,
      navVariant: navExpandedState
    });
  }))));
}

LeftNav.propTypes = _schema.default.propTypes;
var _default = LeftNav;
exports.default = _default;